import { FaBarsIcon } from '../../components/Icons'
import UserProfileMenu from './UserProfileMenu.container'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import ThemeToggle from '../../components/Theme/ThemeToggle'
import { Actions, Box, Container } from './Header.styles'

const Header = ({ onToggleSidebar, isMobile }) => {
  return (
    <Container>
      {isMobile && (
        <FaBarsIcon
          size='20px'
          title='Menú'
          onClick={onToggleSidebar}
        />
      )}
      <Box>
        <Breadcrumb />
      </Box>
      <Actions>
        <ThemeToggle />
        <UserProfileMenu />
      </Actions>
    </Container>
  )
}

export default Header
